
exports.changeRecordsPerPage = function(e, el) {
	//TODO would this work in all cases? Maybe would be better to get a reference to app from derby-ui-paginator/index.js
	var app = DERBY.app;

	//TODO figure out why e.get('recordsPerPage') always returns the previous selection
	//rather than the number that was just selected.
	//We just do it manually for now
	var recordsPerPage = el.options[el.selectedIndex].value;
	
	var paginator = e.get(':paginator');
	//re-query the current page
	app.history.push(paginator.currentBaseUrl + 'page=1&recordsPerPage='+recordsPerPage);
}
